export type ToolName =
  | 'eligibilityRuleQuery'
  | 'pricingFormula'
  | 'contentEn'
  | 'contentEsXl'
  | 'contentEs'
  | 'contentFr'
  | 'contentDe'
  | 'contentSk'
  | 'contentEl'
  | 'contentIt'
  | 'contentMs'
  | 'contentEnUs'
  | 'contentVi'
  | 'contentZh'
  | 'contentJa'
  | 'contentKo'
  | 'contentPl'
  | 'contentTr'
  | 'contentPt'
  | 'contentHu'
  | 'contentIo';

export interface ChatMessage {
  message: string;
  background?: string;
  isUser: boolean;
}
export const FollowUpType = {
  // Used to display a message in the chat window to the user from the agent,
  ChatMessage: 'ChatMessage',
  // Update the controlled form input with the new value
  UpdateInput: 'UpdateInput',
  // Switch the user's selected agent option (e.g. create->modify)
  SwitchOption: 'SwitchOption',
  // Continue the conversation with the current agent
  ContinueConversation: 'ContinueConversation',
  // Mark the agent as executed
  SetExecuted: 'SetExecuted',
  // Do not proceed with the current agent
  SetTerminal: 'SetTerminal',
} as const;

export type FollowUpType = (typeof FollowUpType)[keyof typeof FollowUpType];

export const InvalidArgumentError = new Error('Invalid argument');
